import React from "react";

const Support = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Support</h1>
    </div>
  );
};

export default Support;
